module.exports = __webpack_public_path__ + "img/CAA094_875343_956255_EADEDC-256px.b9625a37.png";